import React from "react";

import AtomInputButton from "./AtomInputButton";

const AtomicWeightsInput: React.FC = () => {
    return (
        <div className="atom-input">
            <div className="periodic-table">
                <div className="table-row">
                    <AtomInputButton number={1}/>
                    <div style={{ flexGrow: 16 }}/>
                    <AtomInputButton number={2}/>
                </div>
                <div className="table-row">
                    <AtomInputButton number={3}/>
                    <AtomInputButton number={4}/>
                    <div style={{ flexGrow: 10 }}/>
                    <AtomInputButton number={5}/>
                    <AtomInputButton number={6}/>
                    <AtomInputButton number={7}/>
                    <AtomInputButton number={8}/>
                    <AtomInputButton number={9}/>
                    <AtomInputButton number={10}/>
                </div>
                <div className="table-row">
                    <AtomInputButton number={11}/>
                    <AtomInputButton number={12}/>
                    <div style={{ flexGrow: 10 }}/>
                    <AtomInputButton number={13}/>
                    <AtomInputButton number={14}/>
                    <AtomInputButton number={15}/>
                    <AtomInputButton number={16}/>
                    <AtomInputButton number={17}/>
                    <AtomInputButton number={18}/>
                </div>
                <div className="table-row">
                    <AtomInputButton number={19}/>
                    <AtomInputButton number={20}/>
                    <AtomInputButton number={21}/>
                    <AtomInputButton number={22}/>
                    <AtomInputButton number={23}/>
                    <AtomInputButton number={24}/>
                    <AtomInputButton number={25}/>
                    <AtomInputButton number={26}/>
                    <AtomInputButton number={27}/>
                    <AtomInputButton number={28}/>
                    <AtomInputButton number={29}/>
                    <AtomInputButton number={30}/>
                    <AtomInputButton number={31}/>
                    <AtomInputButton number={32}/>
                    <AtomInputButton number={33}/>
                    <AtomInputButton number={34}/>
                    <AtomInputButton number={35}/>
                    <AtomInputButton number={36}/>
                </div>
                <div className="table-row">
                    <AtomInputButton number={37}/>
                    <AtomInputButton number={38}/>
                    <AtomInputButton number={39}/>
                    <AtomInputButton number={40}/>
                    <AtomInputButton number={41}/>
                    <AtomInputButton number={42}/>
                    <AtomInputButton number={43}/>
                    <AtomInputButton number={44}/>
                    <AtomInputButton number={45}/>
                    <AtomInputButton number={46}/>
                    <AtomInputButton number={47}/>
                    <AtomInputButton number={48}/>
                    <AtomInputButton number={49}/>
                    <AtomInputButton number={50}/>
                    <AtomInputButton number={51}/>
                    <AtomInputButton number={52}/>
                    <AtomInputButton number={53}/>
                    <AtomInputButton number={54}/>
                </div>
                <div className="table-row">
                    <AtomInputButton number={55}/>
                    <AtomInputButton number={56}/>
                    <div style={{ flexGrow: 1 }}/>
                    <AtomInputButton number={72}/>
                    <AtomInputButton number={73}/>
                    <AtomInputButton number={74}/>
                    <AtomInputButton number={75}/>
                    <AtomInputButton number={76}/>
                    <AtomInputButton number={77}/>
                    <AtomInputButton number={78}/>
                    <AtomInputButton number={79}/>
                    <AtomInputButton number={80}/>
                    <AtomInputButton number={81}/>
                    <AtomInputButton number={82}/>
                    <AtomInputButton number={83}/>
                    <AtomInputButton number={84}/>
                    <AtomInputButton number={85}/>
                    <AtomInputButton number={86}/>
                </div>
                <div className="table-row">
                    <AtomInputButton number={87}/>
                    <AtomInputButton number={88}/>
                    <div style={{ flexGrow: 1 }}/>
                    <AtomInputButton number={104}/>
                    <AtomInputButton number={105}/>
                    <AtomInputButton number={106}/>
                    <AtomInputButton number={107}/>
                    <AtomInputButton number={108}/>
                    <AtomInputButton number={109}/>
                    <AtomInputButton number={110}/>
                    <AtomInputButton number={111}/>
                    <AtomInputButton number={112}/>
                    <AtomInputButton number={113}/>
                    <AtomInputButton number={114}/>
                    <AtomInputButton number={115}/>
                    <AtomInputButton number={116}/>
                    <AtomInputButton number={117}/>
                    <AtomInputButton number={118}/>
                </div>

                <div className="table-row"/>

                <div className="table-row">
                    <div style={{ flexGrow: 3 }}/>
                    <AtomInputButton number={57}/>
                    <AtomInputButton number={58}/>
                    <AtomInputButton number={59}/>
                    <AtomInputButton number={60}/>
                    <AtomInputButton number={61}/>
                    <AtomInputButton number={62}/>
                    <AtomInputButton number={63}/>
                    <AtomInputButton number={64}/>
                    <AtomInputButton number={65}/>
                    <AtomInputButton number={66}/>
                    <AtomInputButton number={67}/>
                    <AtomInputButton number={68}/>
                    <AtomInputButton number={69}/>
                    <AtomInputButton number={70}/>
                    <AtomInputButton number={71}/>
                </div>
                <div className="table-row">
                    <div style={{ flexGrow: 3 }}/>
                    <AtomInputButton number={89}/>
                    <AtomInputButton number={90}/>
                    <AtomInputButton number={91}/>
                    <AtomInputButton number={92}/>
                    <AtomInputButton number={93}/>
                    <AtomInputButton number={94}/>
                    <AtomInputButton number={95}/>
                    <AtomInputButton number={96}/>
                    <AtomInputButton number={97}/>
                    <AtomInputButton number={98}/>
                    <AtomInputButton number={99}/>
                    <AtomInputButton number={100}/>
                    <AtomInputButton number={101}/>
                    <AtomInputButton number={102}/>
                    <AtomInputButton number={103}/>
                </div>
            </div>
        </div>
    );
}

export default AtomicWeightsInput;
